import { BaseModal, BaseModalProps } from '@anytag/shared-atoms';

export type WarningModalProps = BaseModalProps;

export const WarningModal = ({ footer, onClose, ...restProps }: WarningModalProps) => (
  <BaseModal
    onClose={onClose}
    {...restProps}
    footer={{
      ...footer,
      submitButton: { onClick: onClose, ...footer?.submitButton }
    }}
  />
);
